import { notification } from "antd";
import { ApolloError } from "apollo-client";
import { useState } from "react";
import { Api } from "../../common/Api";

export const useEditRegion = ({ refresh }) => {
  const [visible, setVisible] = useState(false);
  const [saving, setSaving] = useState(false);
  const [model, setModel] = useState<any>();

  const edit = (model) => {
    const { id, name, directorId, directorIds } = model;
    setModel({ id, name, directorId, directorIds });
    setVisible(true);
  };

  const check = (name) => {
    return Api.region.check({ id: model.id, name }).then((res) => res.data.checkRegion);
  };

  const save = (values) => {
    setSaving(true);
    return Api.region
      .save({ id: model.id, ...values })
      .then((res) => {
        setVisible(false);
        notification.success({ message: `Region ${values.name} saved` });
        refresh();
      })
      .catch((err: ApolloError) => {})
      .finally(() => setSaving(false));
  };

  const close = () => {
    setVisible(false);
  };

  return {
    visible,
    saving,
    model,
    edit,
    check,
    save,
    close,
  };
};
